module.exports = __webpack_public_path__ + "media/images/promo/championship/digits/9-a5bda1d8da2e2e59cdbe37b689f8bb7f.png";